import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import contactService from './contactService'

const initialState = {
	contact: {},
	isError: false,
	isSuccess: false,
	isLoading: false,
	message: '',
}

// Create a new contact
export const createContact = createAsyncThunk('contact/create', async (contactData, thunkAPI) => {
	try {
		const response = await contactService.createContact(contactData)

		return response
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString()

		return thunkAPI.rejectWithValue(message)
	}
})

export const contactSlice = createSlice({
	name: 'contact',
	initialState,
	reducers: {
		reset: (state) => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(createContact.pending, (state) => {
				state.isLoading = true
			})
			.addCase(createContact.fulfilled, (state) => {
				state.isLoading = false
				state.isSuccess = true
			})
			.addCase(createContact.rejected, (state, action) => {
				state.isLoading = false
				state.isError = true
				state.message = action.payload
			})
	},
})

export const { reset } = contactSlice.actions
export default contactSlice.reducer
